// extracted by mini-css-extract-plugin
module.exports = {"btnSpacing":"style__btnSpacing__nALUB"};